import HeaderRouteIndicatior from "../../Molecules/HeaderRouteIndicator/HeaderRouteIndicator";
import "./SuccesCaseHeaderSection.scss";
// import FS_CASOSDEEXITO_DETALLE_IMAGEN_1 from "../../../assets/img/FS-CASOSDEEXITO-DETALLE-IMAGEN-1.jpg";

const SuccesCaseHeaderSection = ({ title, img }) => {
	return (
		<>
			<HeaderRouteIndicatior
				route={[
					{ text: "INICIO", route: "/" },
					{ text: "CASOS DE ESTUDIO", route: "/casos-de-exito" },
					{ text: title.toUpperCase(), route: undefined },
				]}
			/>
			<div className="grid fullColumn succesCaseHeaderSection-container">
				<div className="succesCaseHeaderSection--text-container max-width all-columns">
					<h5 className="t5 c-yellow center-text yellow-line both-sides">
						CASO DE ÉXITO
					</h5>
					<h2 className="t2 c-white center-text no-space">{title}</h2>
				</div>
				<div className="succesCaseHeaderSection--image-container hypertext-width all-columns">
					<img
						src={img}
						alt="Mujer Conduciendo"
						className="succesCaseHeaderSection-image all-width-height aspect-ratio cover"
					/>
				</div>
				<div className="succesCaseHeaderSection-blue-bg all-columns"></div>
				<div className="succesCaseHeaderSection-white-bg all-columns"></div>
			</div>
		</>
	);
};

export default SuccesCaseHeaderSection;
